export const mapSyncDraftMetaToDashboardCounts = (offersIsSellingCount, draftsData = {}) => ({
  offersAllCount: draftsData.total,
  offersIsSellingCount,
  offersNotSellingCount: draftsData.total - offersIsSellingCount,
  offersWithErrorsCount: draftsData.count_errors,
  offersIsNeedActionCount: draftsData.need_action
})
